// POST /api/jobs/subscription-cycle/run
export interface RunSubscriptionCycleParams {
  facilityId?: string;
  forceCycleClosureEvenIfNotDue?: boolean;
}

export interface RunSubscriptionCycleResult {
  stripeEnabled: boolean;
  considered: number;
  invoiced: number;
  nothingOwed: number;
  notDue: number;
  noBillingAddress: number;
  failures: string[];
}
